
<div [ngClass]="{'defaultMode': !darkMode,'darkMode': darkMode}" style="margin-top: 15px">
  <div style="flex-wrap: wrap; width: 100%;">
    <h3 style="text-align: center;">
      Generate Custom Transaction Report
    </h3>
  </div>

  <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
    <div style="min-width: 750px;">
      <div style="width: 40%; text-align: end; display: inline-block;">
        <label style="margin-top: 8px;">Scale Ticket Date Range:</label>
      </div>
      <div style="display: inline-block;">
        <div class="input-group input-group-sm" style="width: 15em; margin-left: 1em;">
          <input [value]="filterDateFrom ? (filterDateFrom | date: 'MM/dd/yyyy') + ' - ' + (filterDateTo | date: 'MM/dd/yyyy') : ''"
            placeholder="Date Range" id="dateRange" name="dateRange"
            #scaleticketDateRange
            bsDaterangepicker
            [bsConfig]="bsConfig"
            (bsValueChange)="dateRangeChange($event)"
            style="min-width: 300px;"
            class="form-control"
            [ngClass]="{'btn-dark': darkMode}"
            aria-describedby="cal-addon"
            matTooltip="Set a Payment date range filter"
            aria-label="Payment Dash Date Range">
        </div>
      </div>
    </div>
  </div>

  <div class="row" style="justify-content: center; margin-bottom: 0.5em;">
    <div style="height: 40px; min-width: 750px;">
      <div>
        <label style="width: 40%; text-align: end; margin-right: 1em;">Customer(s): </label>
        <div style="display: inline-block;">
          <b style="margin-right: 1em;">{{ customers.length == 0 || customers.length == allCustomers.length ? "All Customers" : (customers.length == 1 ? customers[0].organization : (customers.length + ' Customers')) }}</b>
          <button class="headerButton" (click)="openCustomerSelection()" matTooltip="Select Customer" matTooltipPosition="right" style="float: right;">
            <i class="far fa-address-book"></i>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="selectCustomerMode" class="dialogBox dashModule" [ngClass]="{'darkMode':darkMode}" style="padding-left: 0; padding-right: 0; padding-bottom: 0; height: auto;">
  <div class="scaleTicketRow" style="justify-content: center;" [ngClass]="{'darkMode':darkMode}">
    <h4 class="boxTitle" style="text-align: center;">
      <i class="fal fa-fw fa-address-book"></i> Manage Customer Selections
    </h4>
    <div style="position: absolute; right: 1em; top: 0.5em;" class="d-flex align-items-center">
      <button matTooltip="Clear Selection" (click)="deselectCustomer()" class="btn btn-dark me-2" *ngIf="customers.length > 0">
       Clear Selection <i class="fas fa-eraser"></i>
      </button>
      <button matTooltip="Close" (click)="closeCustomerSelectComponent()" class="btn btn-outline-secondary">
        <i class="fas fa-times"></i>
      </button>
    </div>
  </div>
  <br>
  <div class="card-body" style="padding-top: 0;" [ngClass]="{'darkMode':darkMode}">
    <div class="text-center small alert alert-info mt-0 mb-2" *ngIf="isProcessing">
      <div title="Please wait..." class="ball-pulse">
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
    <lib-customer-select #customerSelect *ngIf="!isProcessing"
      [darkMode]="darkMode"
      [currentCustomers]="customers"
      [dateRange]="!showAll ? [filterDateFrom, filterDateTo] : []"
      [stStatus]="filterStatus"
      [customerSvc]="contactSvc"
      (selectionEmitter)="selectCustomer($event)"
      (hardSelectionEmitter)="selectCustomer($event)"
      (selectionUpdatedEmitter)="selectAllCustomers()">
      Select Customer for Transaction Report
    </lib-customer-select>
  </div>
</div>

<div class="card-footer" style="bottom: 0px; left: 0px; width: 100%;" [ngStyle]="{'position': selectCustomerMode? 'relative': 'absolute'}">
  <div class="btn-group d-flex w-100 m-0" style="border-bottom: none;" role="group">
    <button type="button" aria-label="Cancel Report Creation" (click)="wizardCancelledEmitter.emit()" class="btn wizardBtn wizardBtn-cancel" matTooltip="Cancel Report Wizard" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false"
      [ngClass]="{'btn-warning': darkMode, 'btn-outline-warning': !darkMode && !glassMode, 'btn-light': glassMode}">
      <i class="fa-lg fa-window-close me-1" [ngClass]="{'fas': darkMode, 'fal': !darkMode}"></i>
      Cancel
    </button>
    <button [disabled]="isProcessing" type="submit" aria-label="Generate" (click)="generateReport(filterParams)" class="btn wizardBtn wizardBtn-next"
      [ngClass]="{'btn-success': darkMode, 'btn-outline-success': !darkMode && !glassMode, 'btn-light': glassMode}" matTooltip="Generate Report" [matTooltipDisabled]="appGlobals.getTooltipDisplay() != null ? (!appGlobals.getTooltipDisplay() ? true : false) : false">
      <i class="fa-check-square fa-lg ms-1" [ngClass]="{'fas': darkMode, 'fal': !darkMode}"></i>
      Submit
    </button>
  </div>
</div>
